// toastService.js
import { createApp } from 'vue';
import ToastService from 'primevue/toastservice';
import App from '@/App.vue'; // Make sure to adjust the path if needed

// Initialize PrimeVue and register ToastService
const app = createApp(App);
app.use(ToastService);
const toastService = app.config.globalProperties.$toast;

export default toastService;